module.exports = {"652301001":"宁边路","652301002":"延安北路","652301003":"北京南路","652301004":"建国路","652301005":"中山路街道","652301006":"绿洲路街道","652301100":"硫磺沟镇","652301101":"三工镇","652301102":"榆树沟镇","652301103":"二六工镇","652301104":"大西渠镇","652301105":"六工镇","652301106":"滨湖镇","652301107":"佃坝镇","652301202":"阿什里哈萨克民族乡","652301203":"庙尔沟乡","652301400":"新疆昌吉国家农业科技园区管理委员会","652301401":"昌吉市北部荒漠生态保护管理站","652301402":"昌吉国家高新技术产业开发区","652301503":"兵团共青团农场","652301504":"兵团军户农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652301.json
// module id = 3071
// module chunks = 0